import React , {useContext} from 'react'
import "./instructions.css"
import { MainTitle } from "../../../../components/mini-components/mini-components.jsx"
import UserContext from '../../../../context/user_context'
import CartContext from "../../../../context/cart_context.js";


const Instructions = () => {
  const {  userInfo} = useContext(UserContext);  
  const {  instructionsRef} = useContext(CartContext);  

  const handleinstruct = () => {
    if(instructionsRef != null){
      console.log(instructionsRef.current.value);
      }  
  }
  return (
    userInfo != null &&
    <div className='checkout-item-container instruction-container'>
       <MainTitle title={"Instructions"} />
       <textarea  ref={instructionsRef}
       onChange={handleinstruct}
          placeholder='Add food instructions....'
          
       />
    </div>
  )
}

export default Instructions